import { divIcon } from "leaflet";
// handles the custom rendering of an icon
// the first parameter is if we want to display a number in the pin, it will add it to the html,
// if we want the pin to display an icon then number will be null
// className is passed as an argument because conditional logic for highlighting the pin
export const pinDiv = (number, className = "pin-icon") =>
	new divIcon({
		className,
		html: number,
		iconSize: [40, 50],
		iconAnchor: [15, 40], // need an offset of where the pin is actually and where the icon appears
	});
